import { Controller } from "@hotwired/stimulus"
import api from "@/utils/api"

export default class extends Controller {
  static targets = ["priceCalculation", "variantCheckbox", "scopeCheckbox", "licenseCount", "submitButton"]
  static values = { 
    fontListingExtId: String,
    fontExtId: String,
    calculateUrl: String
  }

  get flashesController() {
    return this.application.getControllerForElementAndIdentifier(document.getElementById("flashesContainer"), "components--flashes")
  }

  connect() {
    // 초기 가격 계산 - DOM이 완전히 로드된 후 실행
    setTimeout(() => {
      this.calculatePrice()
      this.validateForm()
    }, 100)
  }

  // 체크박스 변경 이벤트
  checkboxChanged(event) {
    this.calculatePrice()
    this.validateForm()
  }

  // 인원수 증가
  increaseLicenseCount() {
    const currentValue = this.getLicenseCount()
    this.licenseCountTarget.value = currentValue + 1
    this.calculatePrice()
  }

  // 인원수 감소
  decreaseLicenseCount() {
    const currentValue = this.getLicenseCount()
    if (currentValue > 1) {
      this.licenseCountTarget.value = currentValue - 1
      this.calculatePrice()
    }
  }

  // 인원수 직접 변경 이벤트
  licenseCountChanged(event) {
    const value = parseInt(event.target.value)
    if (isNaN(value) || value < 1) {
      event.target.value = 1
    }
    this.calculatePrice()
  }

  // 가격 계산 요청
  calculatePrice() {
    const licenseScopes = this.getSelectedScopes()
    const fontVariants = this.getSelectedVariants()
    const licenseCount = this.getLicenseCount()

    const params = {
      font_listing_ext_id: this.fontListingExtIdValue,
      license_scope_ids: licenseScopes,
      font_variant_ids: fontVariants,
      license_count: licenseCount
    }

    api.post(this.calculateUrlValue, params, {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
    })
    .then(response => {
      if (response.data.html) {
        this.priceCalculationTarget.innerHTML = response.data.html
      }
    })
    .catch(error => {
      console.error('Price calculation error:', error)
    })
  }

  // 선택된 사용범위 가져오기
  getSelectedScopes() {
    if (!this.hasScopeCheckboxTarget) return []
    return Array.from(this.scopeCheckboxTargets)
      .filter(checkbox => checkbox.checked)
      .map(checkbox => checkbox.value)
  }

  // 선택된 폰트 종수 가져오기
  getSelectedVariants() {
    if (!this.hasVariantCheckboxTarget) return []
    return Array.from(this.variantCheckboxTargets)
      .filter(checkbox => checkbox.checked)
      .map(checkbox => checkbox.value)
  }

  // 라이선스 수량 가져오기
  getLicenseCount() {
    if (!this.hasLicenseCountTarget) return 1
    return parseInt(this.licenseCountTarget.value) || 1
  }

  // 폼 유효성 검사
  validateForm() {
    if (!this.hasSubmitButtonTarget) return

    const selectedVariants = this.getSelectedVariants()
    const hasVariantsSelected = selectedVariants.length > 0
    this.submitButtonTarget.disabled = false

    if (hasVariantsSelected) {
      this.submitButtonTarget.classList.add("cursor-pointer")
      this.submitButtonTarget.classList.remove('opacity-50', 'cursor-not-allowed', "hover:opacity-50")
    } else {
      this.submitButtonTarget.classList.remove("cursor-pointer")
      this.submitButtonTarget.classList.add('opacity-50', 'cursor-not-allowed', "hover:opacity-50")
    }
  }

  // 폼 제출 이벤트 핸들러
  handleSubmit(event) {
    const selectedVariants = this.getSelectedVariants()

    if (selectedVariants.length === 0) {
      let flashParams = { ttl: 15, stack: false, key: "alert" };
      flashParams.message = `구매할 폰트 종수를 먼저 선택해주세요.`;
      this.flashesController.createFlash(flashParams);
      event.preventDefault()

      return false
    }

    return true
  }
}